import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled, { css, ThemeProvider } from 'styled-components';
import { gray10, gray25, gray40, gray45, gray60, gray75, gray95 } from '@spotify-internal/encore-foundation';
import { buttonReset } from "../../styles"; // eslint-disable-next-line prefer-arrow-callback

var ButtonIconComponent = styled(function ButtonIconComponent(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'button' : _ref$component,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? {} : _ref$theme,
      props = _objectWithoutProperties(_ref, ["component", "theme"]);

  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(Component, props));
}).withConfig({
  displayName: "ButtonIcon__ButtonIconComponent",
  componentId: "sc-1yjgouk-0"
})(["", ";cursor:inherit;display:inline-flex;", ";", ";"], function (props) {
  return (!props.component || props.component === 'button') && css(["", ";"], buttonReset());
}, function (props) {
  var _props$theme;

  return ((_props$theme = props.theme) == null ? void 0 : _props$theme.buttonIcon) !== 'dark' && css(["color:", ";&:hover{color:", ";}&:active{color:", ";}&:focus{color:", ";}"], gray45, gray10, gray25, gray40);
}, function (props) {
  return props.theme.buttonIcon === 'dark' && css(["color:", ";&:hover{color:", ";}&:active{color:", ";}&:focus{color:", ";}"], gray45, gray95, gray75, gray60);
});
var buttonIconHelper = {
  darkTheme: {
    buttonIcon: 'dark'
  }
};
export var ButtonIcon = Object.assign(ButtonIconComponent, buttonIconHelper);
export default ButtonIcon;